import { render, staticRenderFns } from "./NetlinkPopupTable.vue?vue&type=template&id=08f531ba&scoped=true"
import script from "./NetlinkPopupTable.vue?vue&type=script&lang=js"
export * from "./NetlinkPopupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f531ba",
  null
  
)

export default component.exports